import { ButtonInputWithPopover } from "@msys/ui";
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";
import { useTranslate } from "@tolgee/react";
import {
  FilterChipGroup,
  FilterChipGroupProps,
} from "../../../commons/filters/FilterChip.js";
import { FilterProps } from "../../../commons/filters/index.js";
import {
  QuoteBindingTypeFilter,
  useQuoteBindingTypes,
} from "../useBindingTypes.js";

export function QuotesBindingFilterButton(
  props: FilterProps<QuoteBindingTypeFilter[]>
) {
  const { t } = useTranslate(["QuoteFilter"]);
  const { bindingTypeOptions } = useQuoteBindingTypes();

  return (
    <ButtonInputWithPopover
      label={t("Binding type", { ns: "QuoteFilter" })}
      counter={
        props.value &&
        props.value.length > 0 &&
        props.value.length < bindingTypeOptions.length
          ? props.value.length
          : undefined
      }
      content={<QuotesBindingFilterForm {...props} />}
      popoverWidth="md"
    />
  );
}

function QuotesBindingFilterForm({
  value,
  setValue,
}: FilterProps<QuoteBindingTypeFilter[]>) {
  const { bindingTypeOptions } = useQuoteBindingTypes();

  return (
    <Box p={1}>
      <FormControl component="fieldset" variant="standard">
        <FormGroup>
          {bindingTypeOptions.map((option, index) => (
            <FormControlLabel
              control={
                <Checkbox
                  size="medium"
                  checked={value.includes(option.value)}
                  onChange={(_event, checked) => {
                    if (checked) {
                      setValue(Array.from(new Set([...value, option.value])));
                    } else {
                      setValue(value.filter(v => v !== option.value));
                    }
                  }}
                />
              }
              label={<Typography variant="body1">{option.label}</Typography>}
              sx={{ ml: 0, mr: 0 }}
              key={`${option.value}-${index}`}
            />
          ))}
        </FormGroup>
      </FormControl>
    </Box>
  );
}

export function QuotesBindingFilterChips(
  props: Omit<
    FilterChipGroupProps<QuoteBindingTypeFilter>,
    "label" | "getValueLabel"
  >
) {
  const { t } = useTranslate("QuoteFilter");
  const { bindingTypeLabels } = useQuoteBindingTypes();

  return (
    <FilterChipGroup
      label={t("Binding type", { ns: "QuoteFilter" })}
      setValues={props.setValues}
      values={props.values}
      getValueLabel={value => bindingTypeLabels[value]}
    />
  );
}
